import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../hooks/redux';
import { setCurrentConversation } from '../store/reducers/messages.reducer';
import { BirthdayCalendar } from '../components/calendar/BirthdayCalendar';
import { User } from '../types';

export const BirthdayCalendarPage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleOpenChat = (member: User) => {
    dispatch(setCurrentConversation(String(member.id)));
    navigate('/dashboard/messages');
  };

  return (
    <div className="page">
      <div className="container">
        <div className="page-header">
          <h1 className="h3">Birthday Calendar</h1>
          <p className="text-secondary">
            Keep track of family birthdays and celebrate together
          </p>
        </div>
        <BirthdayCalendar onOpenChat={handleOpenChat} />
      </div>
    </div>
  );
};